import React from 'react';
import { useSelector } from 'react-redux';
import { ONBOARDING_ENABLED } from './flags';
import OnboardingLayer from './OnboardingLayer';
import { useReception } from '../../_utils/receptionMode';

/**
 * Router-level host for the onboarding / import layer (mounted next to
 * NewBookingHost). Renders nothing until something opens the layer.
 */
export default function OnboardingHost() {
  const user = useSelector((s) => s.user);
  // A locked front desk: never setup, and the import layer only when the
  // desk may import (Settings switch on; the layer itself drops setup modes).
  const { locked, hiddenAreas } = useReception();
  if (!ONBOARDING_ENABLED) return null;
  if (locked && hiddenAreas.importExport) return null;
  const salonName = user?.userInfo?.hairdresser?.salon?.salonName || localStorage.getItem('salonName') || '';
  // "Setting up Nadia's" reads better than "Setting up Nadia's Salon Ltd";
  // keep whatever the salon calls itself, possessive is left to the name.
  return <OnboardingLayer salonName={salonName ? salonName : 'your salon'} />;
}
